<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AdditionalFixedTabs from "../../components/ui/AdditionalFixedTabs";
import common from "../../helpers/common";

export default {
  mounted() {
    common.setHeaderText('Continuing Education')
  },
  components: {
    AdditionalFixedTabs
  },
  computed: {
    ...mapGetters('attendeeStore', ['attendee', 'CEInfoTabs']),
  },
  data() {
    return {}
  }
}
</script>